'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var nthHookTheme = require('@narvar/nth-hook-theme');
var OrderLookupPage = require('./OrderLookupPage.js');
var ItemSelectorPage = require('./ItemSelectorPage.js');
var PudoPage = require('./PudoPage.js');
var ReviewSummaryPage = require('./ReviewSummaryPage.js');
var ConfirmationPage = require('./ConfirmationPage.js');
var ReturnReasonsPage = require('./ReturnReasonsPage.js');
var PrinterlessInfoPage = require('./PrinterlessInfoPage.js');
var tokens = require('./tokens.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PagedReturnWizard = _ref => {
  let {
    routerType
  } = _ref;
  const Router = routerType === 'Hash' ? reactRouterDom.HashRouter : reactRouterDom.BrowserRouter;
  return /*#__PURE__*/React__default["default"].createElement(Router, null, /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Routes, null, /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: "",
    element: /*#__PURE__*/React__default["default"].createElement(OrderLookupPage["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: "items",
    element: /*#__PURE__*/React__default["default"].createElement(ItemSelectorPage["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: "items/reasons",
    element: /*#__PURE__*/React__default["default"].createElement(ReturnReasonsPage["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: "pudo",
    element: /*#__PURE__*/React__default["default"].createElement(PudoPage["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: "review",
    element: /*#__PURE__*/React__default["default"].createElement(ReviewSummaryPage["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: "confirmation",
    element: /*#__PURE__*/React__default["default"].createElement(ConfirmationPage["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: "printerless-info",
    element: /*#__PURE__*/React__default["default"].createElement(PrinterlessInfoPage["default"], null)
  })));
};
var PagedReturnWizard$1 = nthHookTheme.withThemeProvider(PagedReturnWizard, {
  themeTokens: tokens.themeTokens
});

exports["default"] = PagedReturnWizard$1;
